<div class="stopover-card" (click)="onOpenAttractionDialog()">
    <div class="stopover-card__header">
        <figure class="stopover-card__figure">
            <img [src]="stopover.imageUrl" alt="stopover-image">
        </figure>
    </div>
    <div class="stopover-card__content">
        <div class="stopover-card__point">
            <span>{{ pinAlphabet[stopoverIndex] }}</span>
            <mat-icon class="ic-point" [svgIcon]="eSvgIcons.POINT"></mat-icon>
        </div>

        <div class="stopover-card__details">
            <div class="stopover-card__title">
                <h3>{{ stopover.name }}</h3>
                <div class="stopover-card__footer">
                    @if (isSelected) {
                        <button class="btn-default stopover-btn active"
                                (click)="$event.stopPropagation(); onUnselect.emit(stopover)">
                            {{ 'STOPOVER.SELECTED' | translate }}
                        </button>
                    } @else {
                        <button class="btn-default stopover-btn" (click)="$event.stopPropagation(); onSelect.emit(stopover)">
                            {{ 'STOPOVER.SHOW_ON_MAP' | translate }}
                        </button>
                    }
                </div>
            </div>
            <h4>{{ location }}</h4>
            <p>{{ stopover.description }}</p>
        </div>
    </div>
</div>
